import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
})
export class PhoneFormatPipe implements PipeTransform {
  /*
   * @NOTE The following regex patterns are used to validate and format phone numbers.
   * - _phoneRegex: Matches a full phone number with country, countryCode and number.
   * - _withoutCountryRegex: Matches a phone number with optional country.
   * */
  private readonly _phoneRegex = new RegExp(
    /^(.+?)\s+(\+\d{1,3})\s+([\d\s-]+)$/,
  );
  private readonly _withoutCountryRegex = new RegExp(
    /^(?:.*?(\+\d{1,3}))?\s*([\d\s-]+)$/,
  );
  /*
   * @NOTE the _nonDigitRegex is used to remove all non-digit characters from the phone number.
   * - _standard10CharFormat: Matches a 10-digit phone number and captures the area code, central office code, and line number.
   * - _standard11CharFormat: Matches an 11-digit phone number (including country code) and captures the country code, area code, central office code, and line number.
   * */
  private readonly _nonDigitRegex = new RegExp(/\D/g);

  //fixing ERM-4960
  private _constructCharFormat(phoneNumber: string) {
    const digits = phoneNumber.replace(this._nonDigitRegex, '');

    if (digits.length <= 3) {
      return digits;
    } else if (digits.length <= 6) {
      return digits.replace(/(\d{3})(\d+)/, '$1-$2');
    } else if (digits.length <= 10) {
      return digits.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
    }
    return digits.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1-$2-$3-$4');
  }

  transform(contactNumber: string | undefined, checkAlphaNumeric = false, countryCode?: string): string {
    if (!contactNumber || !contactNumber?.length) return '';

    const trimmed = contactNumber.trim();
    const contact = trimmed.match(this._withoutCountryRegex);

    // not formatted correctly — show unformatted version
    if (!contact) {
      return trimmed;
    }

    const [, extractedCountryCode, rawPhoneNumber] = contact;

    // only perform alphanumeric check + use passed countryCode if flag is enabled
    if (checkAlphaNumeric) {
      if (!rawPhoneNumber?.length || /[a-zA-Z]/.test(rawPhoneNumber)) {
        return trimmed;
      }
    }

    const phoneNumber = rawPhoneNumber.replace(this._nonDigitRegex, '');

    if (!phoneNumber.length) {
      return trimmed;
    }

    const _countryCode = checkAlphaNumeric && countryCode
      ? countryCode
      : extractedCountryCode;

    const _formattedCountryCode = _countryCode
      ? (_countryCode.startsWith('+') ? `(${_countryCode})` : _countryCode)
      : '';

    //fixing ERM-4960
    return `${_formattedCountryCode} ${this._constructCharFormat(phoneNumber)}`.trim();
  }
}
